import { Injectable } from '@zhfe/vue2-di-plugin'
import { UserService } from '@/services/user.service'
import client from '@/client/'
import { LOCALSTORAGE_POSITION_KEY, LOCALSTORAGE_PAY_HEIGHT_KEY } from '@/config/dataMap'

/** 上报数据 */
export interface ReportData{
  main_click?:number,
  main_hover?:number,
  sub_mode?:number,
  user_login?: number
}

@Injectable()
export class VideoHeaderService {
  constructor (private user: UserService) {}

  /** 获取反馈上报id */
  getFeedbackReportId () {
    let id = 35
    if (this.user.loginStatus) {
      if (this.user.isMember) {
        id = 29
      } else {
        id = 36
      }
    }
    return id
  }

  /** 上报 */
  report (reportData = { main_click: 0, main_hover: 0, sub_mode: 0, user_login: 0 } as ReportData) {
    client.home.REPORT.reportHomeOperate(reportData)
  }

  clearScrollPosition () {
    localStorage.removeItem(LOCALSTORAGE_POSITION_KEY)
    localStorage.removeItem(LOCALSTORAGE_PAY_HEIGHT_KEY)
  }
}
